import { Injectable, Inject } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Location } from '@angular/common';


import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public access_tocken = "";
  public Server_URL = "http://localhost:55245/";
  public Quotation_Format = "Format1";
  public System_mac_address = "Not found"
  public Area_Map: boolean = false;
  public NT_Bill_Format = "NT_Format1"
  public Bill_Format = "Format1"
  public Bill_Format1 = "Format6";
  public Vadi_Format = "Format1";
  public check_Unicod: boolean = false;

  public loan_category = "Loan";
  public loan_head = "Collection";
  public TCS_Enable: boolean = true;
  public Balance_SMS = "false";


  public key_value = "";
  public loan_type = "All";

  public Intrest_Format = "Flat"

  public NT_Printer: string = "false";
  public NT_Address: String = "http://localhost:55245/";

  public DB_Vadi_display: boolean = false;
  public Print_Button: boolean = false;

  public Ledger_Update: boolean = true;
  public Cust_Amt: boolean = false;
  public Lfrom = "34";
  public Top = 50;

  public Logo_location = "Letter";
  public Logo_Name = "Qubha";
  public Logo_location_Loin = "Chef";
  public Logo_Sub_Name = "Soft";
  public Phone_No = "9597436220";
  public Lab_Home_Page = "/dashboard/default";
  public header_hide: boolean = false;

  public Cam_Type = "Proof";
  public Proof_Image: any;
  public Visa_Image: any;
  public Empty_Image: any;

  public disp_mmenu: boolean = false;
  public Qmenu: boolean = true;
  public STamilName: boolean = false;
  public Type_Based_Bill_No: boolean = false;
  public Item_Rate_Update: boolean = true;
  public Check_Stock: boolean = false;

  public Image_disp: boolean = false;
  public Ledger_Type = "1";

  public Group_Enable: boolean = false;
  public Print_Bill: boolean = false;

  public Save_Print: boolean = true;
  public Save_Print_Mobile: boolean = false;
  public Save_New: boolean = false;

  public Stockbase_Sales: boolean = false;

  public mobile_menu: boolean = false;

  public User_Master_Rows = [];
  get_User_Master() {
    this.getc("Api/Common/get_User_Master").subscribe((res: any) => {
      this.User_Master_Rows = JSON.parse(res).record;
    });
  }

  public Prof_Required: boolean = true;
  public Req_Camera: boolean = false;

  public from_customer_page: boolean = false;
  public W_height = 0;
  public W_width = 0;

  public SM_Row = [];
  public Sales_Disp_Text2_Visblle: boolean = false;
  public Sales_Disp_Text3_Visblle: boolean = false;

  public Loan_Issue_Page = "/collection/emi-loan-issue";
  public Add_Receipt_Page = "/transaction/add-receipt-entry-two";
  public U_Rights = ""
  public CM_Code = ""
  public Item_Group_ = "1";
  public isadd_Page: boolean = false;
  lenth: number = 0;
  constructor(@Inject(DOCUMENT) private document: Document, private toastr: ToastrService, public datePipe: DatePipe, public http: HttpClient, public router: Router, private _location: Location) {


    if (this.getData()) {

      this.data = JSON.parse(localStorage.getItem('User_Data'));

      try {
        this.Customer_Area = localStorage.getItem('Area');
      } catch { }
      this.Company = "_" + this.data.UM_Company;
      this.Branch = this.data.UM_Branch;
      this.Division = this.data.UM_Division;
      this.CM_Code = this.data.CM_Code;
      if (this.data.Rights_Name.toLowerCase() == "staff") {
        this.UserId = this.data.UM_ID;
      }
      this.Rights_Name = "Admin";
    }


    this.W_height = window.innerHeight;

    this.W_width = window.innerWidth;

    var Today_Date = this.datePipe.transform(new Date(), "dd-MMM-yyyy");

    this.T_Date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.T_Date_Time = this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm");


    this.exp_Date = this.datePipe.transform(new Date(), "MM/yy");
    this.Pay_Date = this.datePipe.transform(new Date(), "yyyy-MM-dd");



    this.Y_Date = this.datePipe.transform(new Date().getDate() - 1, "dd-MMM-yyyy");
    this.Today_Date = Today_Date;



    this.S_From_ = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.S_From = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.S_To = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.rep_From_ = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.rep_To_ = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.From_Date = { formatted: Today_Date };
    this.To_Date = { formatted: Today_Date };
    this.Date = { formatted: Today_Date };
    this.Date1 = { formatted: Today_Date };


    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    this.load_themes('');


  }

  // Notification helpers that wrap ngx-toastr for consistent usage
  showSuccess(message: string, title: string = 'Success') {
    try { this.toastr.success(message, title); } catch (e) { console.error(e); }
  }

  showInfo(message: string, title: string = 'Info') {
    try { this.toastr.info(message, title); } catch (e) { console.error(e); }
  }

  showWarning(message: string, title: string = 'Warning') {
    try { this.toastr.warning(message, title); } catch (e) { console.error(e); }
  }

  showError(message: string, title: string = 'Error') {
    try { this.toastr.error(message, title); } catch (e) { console.error(e); }
  }

  public lable_ = "";
  public item = "";
  public Filter_Type = "contain";

  public openModal: boolean = false;
  Open_Modal(Title, page) {
    this.openModal = true;
    $('#small_Module').modal('show');
  }

  Close_Modal() {
    this.openModal = false;
    this.Req_Camera = false;
    $('#small_Module').modal('hide');
  }

  public Header_Disp = "";

  public add_item_name = "/add-items1";
  btndisable: boolean = false;
  isload: boolean = false;
  public Company = "";
  public Branch = "0";
  public Division = "";
  public UserId = "0";
  public CREATED_BY = "";
  public Ref_ID = "0";
  public isadd = "0";
  public Edit_Row: any = {};
  public Edit_Row1: any = {};

  public Selected_Row: any = {};
  public Default_ref_ID: string = "Role";
  public URL_Location = "";

  public disp_category: boolean = false;
  public img_visible: boolean = false;


  public Date;
  public Date1;
  public From_Date;
  public To_Date;
  public S_From_ = "";
  public S_To_ = "";

  public rep_From_ = "";
  public rep_To_ = "";

  public User_Type = "Admin";
  public Document_Type = "Front_Banner";
  public Phone_Pattern = "^((\\+91-?)|0)?[0-9]{10}$";
  public Receipt_Print = "false";

  public Side_Menu: boolean = false;
  public Today_Date = "";
  public S_From = "";
  public S_To = "";
  public FS_Date = "2021-04-01";

  public S_Bill_Type = "All";
  public S_Thari_Status = "All";
  public Calibration_Standard = "";
  public Category = "All";

  public S_Pay_Mode = "0";
  public S_Bill_Mode = "All";
  public S_Area = "All"
  public S_Sales_Order_by = "Bill_No";
  public S_Stock = "All"
  public S_Sales_Person = "All"
  public S_Type = "1"


  public Y_Date = "";
  public data: any = {};
  public Order_Status = "Pending";
  public Search_User = "All";
  public Approval_Status = "Pending";


  public Customer_Area = "All";
  public item_name_disp = "English";

  public T_Date = "";
  public T_Date_Time = "";

  public Default_Payment_ID: string = "Cash";
  public Default_Bank_ID: string = "0";
  public DF_Paymode = "244";
  public T_Status = "A";

  public Pay_Date = "";
  public exp_Date = "";
  public Open_Customer_Total = 0;
  public Open_Customer_Length = 0;
  public DB_Expense_Total = 0;
  public Receipt_Row_Total = 0;
  public Emi_Loan_Issue_Total = 0;
  // public DB_Bank_Row=0;
  public DB_Bank_Total = 0;

  Cash_ID = "CASH";
  Cheque_ID = "CHEQUE";
  Card_ID = "CARD";
  public Item_Group = "";
  public User_Role_Menu = [
    { Menu: 'User Master', Link: '/user-details' },
    { Menu: 'Role Master', Link: '/role-master' },
    { Menu: 'Role Rights', Link: '/role-permissions' }

  ];



  public Menu_Master_GF = ['Module', 'Type', 'Display_Name', 'Route_Link', 'Order_No', 'Icon', 'Remark'];
  public back() {
    this._location.back();
  }


  public datefromat(data) {
    return this.datePipe.transform(data, "yyyy-MM-dd");
  }

  public datetimefromat(data) {
    // Split and rearrange the string to be in 'YYYY-MM-DD HH:mm:ss' format
    const [day, month, yearTime] = data.split("-");
    const [year, time] = yearTime.split(" ");
    const formattedDateStr = `${year}-${month}-${day} ${time}`;

    // Convert the string into a JavaScript Date object
    const dateObj = new Date(formattedDateStr);
    return this.datePipe.transform(dateObj, "yyyy-MM-ddTHH:mm");
  }


  get_dt(date) {
    return this.datePipe.transform(date, "yyyy-MM-dd");
  }

  public date_display(data) {
    if (!data && data !== 0) return '';
    try {
      // If already a Date instance
      if (data instanceof Date) return this.datePipe.transform(data, 'dd-MMM-yyyy');

      let str = String(data).trim();

      // If it's a pure numeric timestamp
      if (/^\d+$/.test(str)) {
        const n = parseInt(str, 10);
        return this.datePipe.transform(n, 'dd-MMM-yyyy');
      }

      // If in dd-MM-yyyy or dd/MM/yyyy format, convert to yyyy-MM-dd
      const ddmmyyyy = /^(\d{2})[-\/](\d{2})[-\/](\d{4})/;
      const m = str.match(ddmmyyyy);
      if (m) {
        str = `${m[3]}-${m[2]}-${m[1]}` + (str.length > 10 ? str.slice(10) : '');
      }

      // Remove trailing time part if present (keep date portion)
      if (str.indexOf(' ') > 0) {
        const parts = str.split(' ');
        // If first part looks like yyyy-mm-dd, keep it
        if (/^\d{4}-\d{2}-\d{2}$/.test(parts[0])) {
          str = parts[0];
        }
      }

      // Try Date parse, try adding T if necessary
      let d = new Date(str);
      if (isNaN(d.getTime())) {
        d = new Date(str.replace(' ', 'T'));
      }
      if (isNaN(d.getTime())) {
        // As a last resort, return original string (so user can see raw value)
        return str;
      }
      return this.datePipe.transform(d, 'dd-MMM-yyyy');
    } catch (e) {
      return String(data);
    }
  }

  public calculateAge(birthDate: Date): number {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birth month/day hasn't occurred yet in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  public Rights_Name = "";
  public Rights_ID = "";
  public Emp_ID = "";

  public Ledger_Rpt = [];
  public To_Amt = "0";
  public Ledger_Amt = "0";
  get_CR_DB_Amount(data) {
    this.get("Api/Transaction/get_CR_DB_Amount?Ledger_ID=" + data).subscribe((res: any) => {
      this.Ledger_Amt = res;
    });
    this.Default_Bank_ID = data;
  }

  onChange_Ledger(data) {
    this.Ledger_Rpt = [];
    this.Ledger_ = "0";
    // this.Ledger_Rpt=this.get_Group_ledger(data);
  }

  getData() {
    return JSON.parse(localStorage.getItem('User_Data'));
  }

  F_Row = [];
  get_pos_field(Table, pos) {

    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.Visible == "True");
    this.F_Row = this.F_Row.filter(e => String(e.Posision).toLowerCase() == String(pos).toLowerCase());
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

  }

  Reference_Rows = [];
  get_Reference() {


    this.getc("Api/Master/get_reference").subscribe((res: any) => {

      this.Reference_Rows = JSON.parse(res).record;
    });
  }

  Product_Rows = [];
  public isEdit: boolean = false;
  public load_from_make_invoice: boolean = false;



  public Default_Search_Branch = "0";


  public Selected_Company: any = {};
  public Selected_Customer: any = {};
  public Current_User: any = {};

  public Order_No = "0";
  public Menus_Rows: any = {};
  public Menu_Rows = [];
  public Label_Menu_Rows = [];
  get_Role_Rights(Role) {
    this.get("Api/Setting/get_Menu_for_user?Rights=" + Role).subscribe((res: any) => {
      this.Menu_Rows = JSON.parse(res).record;
      this.Side_Menu = true;
      try {
        this.Label_Menu_Rows = this.Menu_Rows.filter(e => e.Type == "Label");
        this.Label_Menu_Rows = this.Label_Menu_Rows.filter(e => e.Parent_ID == "0");
        this.Label_Menu_Rows.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
      } catch { }

    });
  }


  get_ref(data) {


    try {
      return this.Reference_Rows.filter(e => e.Ref_ID == data);
    } catch {

      return [];
    }
  }
  get_child(parent) {
    var data = this.Menu_Rows.filter(e => e.Parent_ID == parent).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

    return data;
  }

  get_childs(parent) {
    var data = this.Menu_Rows.filter(e => e.Module == parent).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

    return data;
  }

  public Menu_data = "";
  public Menu_Master_Rows = [];
  public Parent_Menus = [];
  get_Menu_Master() {
    this.getc("Api/Setting/get_Menu_master").subscribe((res: any) => {
      this.Menu_Master_Rows = JSON.parse(res).record;

      this.Parent_Menus = this.Menu_Master_Rows.filter(e => e.Parent_ID == "0");



    });
  }


  loading = false;


  Num(data) {
    return Number(data).toFixed(2);
  }



  public filter_data = "";
  pdfType = "Open";


  get(url) {
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.Server_URL + "" + url + "&Company=" + this.Company, { headers: reqHeader })
  }

  getc(url) {

    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.access_tocken
    });

    return this.http.get(this.Server_URL + "" + url + "?Company=" + this.Company, { headers: reqHeader });
  }



  d_get(url) {


    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });


    return this.http.get(url + "&Company=" + this.Company, { headers: reqHeader })
  }


  public load_page(data) {
    this.router.navigate([data], { replaceUrl: true });
  }

  public load_page1(data) {
    this.router.navigate([data]);
  }


  public Serial_No_Settings_Rows = [];
  public Perment_Serial_No_Settings_Rows = [];
  public Reset_Serial_No_Settings_Row = [];
  public Orderby_Name = "Name";
  get_Serial_No_Settings() {

    this.loading = true;
    this.isload = true;
    this.Serial_No_Settings_Rows = [];
    this.get("Api/Setting/get_Serial_No_Settings?Order_by=" + this.Orderby_Name).subscribe((res: any) => {
      this.Serial_No_Settings_Rows = JSON.parse(res).record;
      this.Perment_Serial_No_Settings_Rows = JSON.parse(res).record;
      this.Reset_Serial_No_Settings_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      //   this.Item_Category = [...new Set(this.Item_Master_Rows.map(item => item.Category))];

      // console.log(this.Item_Category);
    });
  }


  public Variable_Settings_Rows = [];
  public Perment_Variable_Settings_Rows = [];
  public Reset_Variable_Settings_Row = [];
  public Variable_Settings_GF = ['ID', 'S_Variable', 'S_Value', 'S_Default'];

  get_Variable_Settings() {

    this.loading = true;
    this.Variable_Settings_Rows = [];
    this.getc("Api/Setting/get_variable_Settings").subscribe((res: any) => {
      this.Variable_Settings_Rows = JSON.parse(res).record;
      this.Perment_Variable_Settings_Rows = JSON.parse(res).record;
      this.Reset_Variable_Settings_Row = JSON.parse(res).record;
      this.loading = false;

    });
  }

  public Bank_Master_Rows = [];
  get_Bank_Master() {

    this.getc("Api/Master/get_Bank_Master").subscribe((res: any) => {
      this.Bank_Master_Rows = JSON.parse(res).record;
    });
  }


  post_data(data, Table) {

    data.Company = this.Company;
    data.Created_by = this.CREATED_BY;
    data.Table_Name = Table;

    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    this.isload = true;
    this.http.post(this.Server_URL + 'api/Master/Post_Data', data, { headers: this.headers })
      .subscribe(
        (val: string) => {
          this.isload = false;
          return val;
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

    //return "Problem"
  }



  public tocken = "";
  get_Token() {

    this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.isload = true;
    this.http.post(this.Server_URL + 'token', 'grant_type=password&UserName=admin&Password=admin', { headers: this.headers })
      .subscribe(
        (val) => {
          this.tocken = val['access_token'];

        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

    //return "Problem"
  }

  public filteredValue(dt) {

    var len = 0;
    var dt2 = [];
    try {
      len = dt.filteredValue.length;
      dt2 = dt.filteredValue;
      return dt2
    } catch { }


    if (len == 0) {
      try {
        dt2 = dt.value;
      } catch { }
    }

    return dt2;
  }

  public length_of(dt) {

    var len = 0;
    try {
      len = dt.filteredValue.length;
      return len
    } catch { }


    if (len == 0) {
      try {
        len = dt.value.length;
      } catch { }
    }

    return len;
  }

  load_themes(data) {
    var d = "default.css";
    try {
      d = localStorage.getItem('Theme');
    } catch { }

    if (d != "default.css" && d != null) {

      this.loadStyle(d);

    }
  }

  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;

      head.appendChild(style);
    }
  }

  public sum_of(dt, field) {

    var len = 0;
    try {
      len = dt.filteredValue.length;
      return dt.filteredValue.reduce((sum, current) => sum + parseFloat(current[field]), 0);
    } catch { }


    if (len == 0) {
      try {
        len = dt.value.length;
        return dt.value.reduce((sum, current) => sum + parseFloat(current[field]), 0);
      } catch { }
    }

    return len;
  }

  Open_Modal1(Title, page) {
    this.openModal = true;
    $('#small_Module').modal('show');
  }

  public Excel_Data: any = {
    'ID': '',
    "item": '',
    "Header": '',
    "Footer": '',
    "Left_Data": '',
    "Right_Data": '',
    "Report_Name": ''

  };
  headers;

  export_excel() {
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    // Set both item and items fields to ensure compatibility with server-side expectations
    if (this.Excel_Data.item) this.Excel_Data.items = this.Excel_Data.item;
    if (this.Excel_Data.items) this.Excel_Data.item = this.Excel_Data.items;

    const reqHeaders = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data, { headers: reqHeaders, responseType: 'text' })
      .subscribe(
        (val: any) => {
          const result = (val || "").toString().replace(/['"]+/g, '').trim();
          if (result === "True" || result === "true") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.Server_URL + "Home/JsontToExcel?" + parm, "_blank");
            this.toastr.success("Data Exported Successfully", 'Msg');
          }
          else {
            console.error('Export Excel failed:', val);
            this.toastr.error(val || "Export failed", "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.error('Export Excel ERROR:', response);
          this.toastr.error('Error ', response.message || response, {
            timeOut: 3000
          });
        });
  }
  upload_excel() {

    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data, { headers: this.headers })
      .subscribe(
        (val: string) => {

          if (val == "True") {

            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.Server_URL + "Report/JsontToExcel_Upload?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');

          }
          else {

            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });

        });

  }
  //loading = false;

  public Dashboard_Row = [];
  get_Dashboard() {

    this.Dashboard_Row = [];
    this.loading = true;

    this.get("Api/Master/get_dashboard?").subscribe((res: any) => {
      this.Dashboard_Row = JSON.parse(res).record;
      this.loading = false;
    });
  }



  public dashboard_data() {

    this.get_Bank_Master();
    this.get_Employee_Details();
    this.get_S_Branch_Details();
    this.get_S_Branch_Details_Rpt();
    this.get_Region_Master();
  }

  File_Name = "Data";

  export_pdf() {
    this.Excel_Data.Company_Data = JSON.parse(JSON.stringify(this.Current_User || {}));
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    // Set both item and items fields to ensure compatibility with server-side expectations
    if (this.Excel_Data.item) this.Excel_Data.items = this.Excel_Data.item;
    if (this.Excel_Data.items) this.Excel_Data.item = this.Excel_Data.items;

    const reqHeaders = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data, { headers: reqHeaders, responseType: 'text' })
      .subscribe(
        (val: any) => {
          const result = (val || "").toString().replace(/['"]+/g, '').trim();
          if (result === "True" || result === "true") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=pdf";
            window.open(this.Server_URL + "PDF/Export_Pdf?" + parm, "_blank");
            this.toastr.success("Data Exported Successfully", 'Msg');
          }
          else {
            console.error('Export PDF failed:', val);
            this.toastr.error(val || "Export failed", "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.error('Export PDF ERROR:', response);
          this.toastr.error('Error ', response.message || response, {
            timeOut: 3000
          });
        });
  }

  get_fields_of(Table) {
    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.Visible == "True");
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

  }

  get_grid_fields_of(Table) {
    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.GVisible == "True");
    return this.F_Row.sort((a, b) => Number(a["GOrder"]) - Number((b["GOrder"])));

  }

  public Field_Setting = [];
  get_Field_Setting() {
    this.getc("Api/Setting/get_Field_Setting").subscribe((res: any) => {
      this.Field_Setting = JSON.parse(res).record;

    });

  }
  public Field_Setting_Table_Row = [];
  get_Field_Setting_Table() {
    this.getc("Api/Setting/get_Field_Setting_Table").subscribe((res: any) => {
      this.Field_Setting_Table_Row = JSON.parse(res).record;

    });
  }

  public Status = "A";

  public S_Employee_Details_Row = [];
  public Search_Employee = "0";
  get_S_Employee_Details() {
    this.isload = true;
    this.S_Employee_Details_Row = [];
    this.get("Api/transaction/get_Employee_Details?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division + "&RptType=Entry").subscribe((res: any) => {
      this.S_Employee_Details_Row = JSON.parse(res).record;
      this.Search_Employee = this.S_Employee_Details_Row[0].value;
      this.isload = false;
    });
  }

  public S_Branch_Details_Row = [];
  public Search_Branch = "0";
  get_S_Branch_Details() {
    this.isload = true;
    this.S_Branch_Details_Row = [];
    this.get("Api/transaction/get_Branch_Details?Branch=" + this.Branch + "&Division=" + this.Division + "&RptType=Entry").subscribe((res: any) => {
      this.S_Branch_Details_Row = JSON.parse(res).record;
      this.Search_Branch = this.S_Branch_Details_Row[0].value;
      this.Default_Search_Branch = this.Search_Branch;
      this.get_S_Employee_Details();
      this.isload = false;
    });
  }

  public Employee_Details_Rows = [];
  get_Employee_Details() {
    this.Employee_Details_Rows = [];
    this.getc("Api/Master/get_Employee_Details1").subscribe((res: any) => {
      this.Employee_Details_Rows = JSON.parse(res).record;
    });
  }

  public S_Employee_Details_Rpt_Row = [];
  public Search_Employee_Rpt = "0";
  get_S_Employee_Details_Rpt() {
    this.isload = true;
    this.S_Employee_Details_Rpt_Row = [];
    this.get("Api/transaction/get_Employee_Details?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division + "&RptType=Reports").subscribe((res: any) => {
      this.S_Employee_Details_Rpt_Row = JSON.parse(res).record;
      this.Search_Employee_Rpt = this.S_Employee_Details_Rpt_Row[0].value;
      this.isload = false;
    });
  }

  public S_Branch_Details_Rpt_Row = [];
  public Search_Branch_Rpt = "0";
  get_S_Branch_Details_Rpt() {
    this.isload = true;
    this.S_Branch_Details_Rpt_Row = [];
    this.get("Api/transaction/get_Branch_Details?Branch=" + this.Branch + "&Division=" + this.Division + "&RptType=Reports").subscribe((res: any) => {
      this.S_Branch_Details_Rpt_Row = JSON.parse(res).record;
      this.Search_Branch_Rpt = this.S_Branch_Details_Rpt_Row[0].value;
      this.get_S_Employee_Details_Rpt();
      this.isload = false;
    });
  }

  public Region_Master_Export = [];
  public Region_order_by = " rm_id asc";
  public Region_Master_Rows = [];
  public Region_Master_col_GF = ['rm_company_name', 'rm_region_name'];

  get_Region_Master() {
    this.isload = true;
    this.get("Api/Master/get_Region_Master?Status=" + this.Status + "&Order_by=" + this.Region_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Region_Master_Rows = JSON.parse(res).record;
    });
  }

  public Branch_Master_Export = [];
  public Branch_order_by = " bm_id asc";
  public Branch_Master_Rows = [];
  public Branch_Master_col_GF = ['bm_company_name', 'bm_branch_name'];

  get_Branch_Master() {
    this.isload = true;
    this.get("Api/Master/get_Branch_Master?Status=" + this.Status + "&Order_by=" + this.Branch_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Branch_Master_Rows = JSON.parse(res).record;
    });
  }



  public Employee_Master_Export = [];
  public Employee_order_by = " emp_id asc";
  public Employee_Master_Rows = [];
  public Employee_Master_col_GF = ['emp_company_name', 'emp_name'];

  get_Employee_Master() {
    this.isload = true;
    this.get("Api/Master/get_Employee_Master?Status=" + this.Status + "&Order_by=" + this.Employee_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Employee_Master_Rows = JSON.parse(res).record;
    });
  }

  public Customer_Master_Export = [];
  public Customer_order_by = " cus_id asc";
  public Customer_Master_Rows = [];
  public Customer_Master_col_GF = ['Cus_Name', 'Cus_Cellno'];

  get_Customer_Master() {
    this.isload = true;
    this.get("Api/Master/get_customer_Master?Status=" + this.Status + "&Order_by=" + this.Customer_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Customer_Master_Rows = JSON.parse(res).record;
      debugger;
      this.Customer_Master_Rows = this.Customer_Master_Rows.filter(e => e.Cus_Type == this.loan_category);
    });
  }

  public Loan_Master_Export = [];
  public Loan_order_by = " lm_id asc";
  public Loan_Master_Rows = [];
  public Loan_Master_col_GF = ['lm_name', 'lm_code'];

  public mortgage_Report = [];
  public auctcion_Report = [];

  get_Loan_Master() {
    this.isload = true;
    this.get("Api/Loan/get_Loan_Master?Status=" + this.Status + "&Order_by=" + this.Loan_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Loan_Master_Rows = JSON.parse(res).record;
    });
  }

  public Loan_advance_Rows = [];
  get_Loan_Advance() {
    this.isload = true;
    this.get("Api/Reports/get_Loan_Advance?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.Loan_advance_Rows = JSON.parse(res).record;
    });
  }

  public Agent_Master_Export = [];
  public Agent_order_by = " am_id asc";
  public Agent_Master_Rows = [];
  public Agent_Master_col_GF = ['am_company_name', 'am_agentname'];

  get_Agent_Master() {
    this.isload = true;
    this.get("Api/Master/get_Agent_Master?Status=" + this.Status + "&Order_by=" + this.Agent_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Agent_Master_Rows = JSON.parse(res).record;
    });
  }


  public Chit_Value_Master_Export = [];
  public Chit_Value_order_by = " cv_id asc";
  public Chit_Value_Master_Rows = [];
  public Chit_Value_Master_col_GF = ['cv_chit_value', 'cv_month'];

  get_Chit_Value_Master() {
    this.isload = true;
    this.get("Api/Master/get_Chit_Value_Master?Status=" + this.Status + "&Order_by=" + this.Chit_Value_order_by).subscribe((res: any) => {
      this.isload = false;

      this.Chit_Value_Master_Rows = JSON.parse(res).record;
    });
  }


  public Loan_Entry_Export = [];
  public Loan_Entry_order_by = " loan_id asc";
  public Loan_Entry_Rows = [];
  public Loan_closing_Rows = [];
  public Loan_Entry_col_GF = ['loan_cusname', 'loan_type', 'loan_no'];

  get_Loan_Entry() {
    this.isload = true;
    this.Lead_Entry_Rows = [];
    this.get("Api/loan/get_Loan_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&loan_type=" + this.loan_type + "&loan_category=" + this.loan_category).subscribe((res: any) => {
      this.isload = false;
      this.Loan_Entry_Rows = JSON.parse(res).record;
    });
  }
  get_Loan_closing() {
    this.isload = true;
    this.Lead_Entry_Rows = [];
    this.get("Api/loan/get_Loan_closing?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&loan_type=" + this.loan_type + "&loan_category=" + this.loan_category).subscribe((res: any) => {
      this.isload = false;
      this.Loan_closing_Rows = JSON.parse(res).record;
    });
  }

  public customer_bank_master_rows = [];
  public customer_bank_master_rows$ = new BehaviorSubject<any[]>([]);
  get_Customer_Bank_Master() {

    this.getc("Api/Master/get_Customer_Bank_Master").subscribe((res: any) => {
      const data = JSON.parse(res).record;
      this.customer_bank_master_rows = data;
      this.customer_bank_master_rows$.next(data);
    });
  }
  public balance_rows = [];
  balance_sheet() {
    this.isload = true;
    this.balance_rows = [];
    this.getc("Api/loan/balance_sheet").subscribe((res: any) => {
      this.isload = false;
      this.balance_rows = JSON.parse(res).record;
      debugger
      this.balance_rows = this.balance_rows.filter(e => e.cus_type == this.loan_category);
    });
  }

  repayment_chart_payment() {
    this.isload = true;
    this.get("Api/Loan/repayment_chart_payment?loanid=" + this.loan_no).subscribe((res: any) => {
      this.isload = false;
      this.Repayment_chart_rows = JSON.parse(res).record;
    });
  }

  public cus_id = "0";
  public cus_name = "";
  public loan_no = "0";
  public paid_Amt: any = 0;
  public interest_Amt: any = 0;
  public Due_Amt: any = 0;
  public Recipt_Total_Amt: any = 0;
  public Repayment_chart_rows = [];
  public Customer_Loan_Rows = [];
  public Ledger_Recipt_Row = [];
  get_customer_Loan(data) {
    this.isload = true;
    this.Customer_Loan_Rows = [];
    this.Due_Amt = 0;
    const obs = this.get("Api/loan/get_customer_Loan?cusid=" + data + "&date=" + this.T_Date + "&Status=" + this.Status + "&Branch=" + this.Search_Branch + "&category=" + this.loan_category)
      .pipe(
        tap((res: any) => {
          this.isload = false;
          try {
            this.Customer_Loan_Rows = JSON.parse(res).record || [];
            console.log('Customer Loan Rows:', this.Customer_Loan_Rows);
            this.interest_Amt = (this.Customer_Loan_Rows.reduce((sum, current) => sum + parseFloat(current.Interest || 0), 0)).toFixed(2);
            this.paid_Amt = (this.Customer_Loan_Rows.reduce((sum, current) => sum + parseFloat(current.loan_intpaid || 0), 0)).toFixed(2);
            this.Due_Amt = (this.Customer_Loan_Rows.reduce((sum, current) => sum + parseFloat(current.loan_amount || 0), 0)).toFixed(2);
          } catch (e) {
            console.error('Failed to parse customer loan response:', e, res);
            this.Customer_Loan_Rows = [];
            this.interest_Amt = "0.00";
            this.paid_Amt = "0.00";
            this.Due_Amt = "0.00";
          }
        })
      );
    return obs;
  }

  public Receipt_AMT = 0;
  public Ledger_Receipt_Rows = []
  get_Ledger_Recipt(data) {
    this.isload = true;

    this.get("Api/Transaction/get_Receipt_Details?From=" + this.S_From + "&To=" + this.S_To + "&Ledger=" + data).subscribe((res: any) => {
      this.Ledger_Receipt_Rows = JSON.parse(res).record;
      this.isload = false;
      this.Receipt_AMT = (this.Ledger_Receipt_Rows.reduce((sum, current) => sum + parseFloat(current.Amount), 0)).toFixed(2);

    });

  }

  public Ledger_details_Rows = [];
  public Customer_Data = [];
  get_party_ledger_list() {
    this.isload = true;

    this.getc("Api/Reports/get_party_ledger_list").subscribe((res: any) => {
      this.Ledger_details_Rows = JSON.parse(res).record;
    });

  }

  public LoanNo_ = "";
  public party_ledger_Rows = [];
  public Loan_Ledger_Rows = [];
  public Interest_Collection_Export = [
    { Field: 'int_receiptno', Name: 'Receipt No', Align: '' },
    { Field: 'int_date', Name: 'Date', Align: '' },
    { Field: 'int_loanno', Name: 'Loan No', Align: '' },
    { Field: 'int_loantype', Name: 'Loan Type', Align: '' },
    { Field: 'int_cusname', Name: 'Customer', Align: '' },
    { Field: 'loan_amount', Name: 'Loan Amount', Align: 'right' },
    { Field: 'int_amount', Name: 'Paid Amount', Align: 'right' },
    { Field: 'int_penalty', Name: 'Penalty', Align: 'right' },
    { Field: 'int_created_by', Name: 'Create By', Align: '' }
  ];
  public Interest_Collection_order_by = " int_id asc";
  public Interest_Collection_Rows = [];
  public Collection_customer_Rows = [];
  public Collection_daywise_Rows = [];
  public Collection_paymode_Rows = [];
  public Collection_type_Rows = [];
  public Interest_Collection_col_GF = ['int_cusname', 'int_loantype', 'int_loanno', 'int_receiptno'];

  get_Interest_Collection() {
    this.isload = true;
    this.Lead_Entry_Rows = [];
    this.Interest_Collection_Rows = [];
    this.get("Api/loan/get_interest_collection?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&loan_type=" + this.loan_type + "&category=" + this.loan_category).subscribe((res: any) => {
      this.isload = false;
      this.Interest_Collection_Rows = JSON.parse(res).record;
      this.Recipt_Total_Amt = (this.Interest_Collection_Rows.reduce((sum, current) => sum + parseFloat(current.int_amount), 0)).toFixed(2);
      this.Receipt_Row_Total = this.Recipt_Total_Amt;


      this.Collection_customer_Rows = [];
      var User = [...new Set(this.Interest_Collection_Rows.map(item => item.int_cusname))];

      for (let data of User) {
        var sum = (this.Interest_Collection_Rows.filter(e => e.int_cusname == data).reduce((sum, current) => sum + parseFloat(current.int_amount), 0)).toFixed(2);
        var count = [...new Set((this.Interest_Collection_Rows.filter(e => e.int_cusname == data)).map(item => item.int_loanno))].length;
        this.Collection_customer_Rows.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.Collection_type_Rows = [];
      var loantype = [...new Set(this.Interest_Collection_Rows.map(item => item.int_loantype))];

      for (let data of loantype) {
        var sum = (this.Interest_Collection_Rows.filter(e => e.int_loantype == data).reduce((sum, current) => sum + parseFloat(current.int_amount), 0)).toFixed(2);
        var count = [...new Set((this.Interest_Collection_Rows.filter(e => e.int_loantype == data)).map(item => item.int_loanno))].length;
        this.Collection_type_Rows.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.Collection_daywise_Rows = [];
      var loanday = [...new Set(this.Interest_Collection_Rows.map(item => item.int_date))];

      for (let data of loanday) {
        var sum = (this.Interest_Collection_Rows.filter(e => e.int_date == data).reduce((sum, current) => sum + parseFloat(current.int_amount), 0)).toFixed(2);
        var count = [...new Set((this.Interest_Collection_Rows.filter(e => e.int_date == data)).map(item => item.int_loanno))].length;
        this.Collection_daywise_Rows.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.Collection_paymode_Rows = [];
      var pay_mode = [...new Set(this.Interest_Collection_Rows.map(item => item.int_paymode))];

      for (let data of pay_mode) {
        var sum = (this.Interest_Collection_Rows.filter(e => e.int_paymode == data).reduce((sum, current) => sum + parseFloat(current.int_amount), 0)).toFixed(2);
        var count = [...new Set((this.Interest_Collection_Rows.filter(e => e.int_paymode == data)).map(item => item.int_loanno))].length;
        this.Collection_paymode_Rows.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

    });
  }


  public Collection_Report = [
    { Menu: 'Loan-wise', Link: '/finance/collection-loanwise', class: '' },
    { Menu: 'Type-Wise', Link: '/finance/collection-typewise', class: '' },
    { Menu: 'Customer-wise', Link: '/finance/collection-customerwise', class: '' },
    { Menu: 'Day-wise', Link: '/finance/collection-daywise', class: '' },
    { Menu: 'Payment-wise', Link: '/finance/collection-paymodewise', class: '' },
  ];


  public Interest_customer_Rows = [];
  get_interest_customer(data) {
    this.isload = true;
    this.Interest_customer_Rows = [];
    this.get("Api/loan/get_interest_customer?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&cusid=" + data).subscribe((res: any) => {
      this.isload = false;
      this.Interest_customer_Rows = JSON.parse(res).record;
    });
  }
  public Lead_Entry_Export = [];
  public Lead_Entry_order_by = " lead_id asc";
  public Lead_Entry_Rows = [];
  public Lead_Entry_col_GF = ['cv_chit_value', 'cv_month'];

  get_Lead_Entry() {
    this.isload = true;
    this.Lead_Entry_Rows = [];
    this.get("Api/transaction/get_Lead_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&Employee=" + this.Search_Employee).subscribe((res: any) => {
      this.isload = false;
      this.Lead_Entry_Rows = JSON.parse(res).record;
    });
  }


  public Followup_Details_Export = [];
  public Followup_Details_order_by = " lead_id asc";
  public Followup_Details_Rows = [];
  public Followup_Details_col_GF = ['cv_chit_value', 'cv_month'];

  get_Followup_Details() {
    this.isload = true;
    this.Followup_Details_Rows = [];
    this.get("Api/transaction/get_Followup_Details?Lead_Type=" + this.S_Type + "&Branch=" + this.Search_Branch + "&Employee=" + this.Search_Employee).subscribe((res: any) => {
      this.isload = false;
      this.Followup_Details_Rows = JSON.parse(res).record;
    });
  }



  public FeedBack_Export = [];
  public FeedBack_order_by = " fd_id asc";
  public FeedBack_Rows = [];
  public FeedBack_col_GF = ['cv_chit_value', 'cv_month'];

  get_FeedBack() {
    this.isload = true;
    this.FeedBack_Rows = [];
    this.get("Api/transaction/get_FeedBack?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&Employee=" + this.Search_Employee).subscribe((res: any) => {
      this.isload = false;
      this.FeedBack_Rows = JSON.parse(res).record;
    });
  }



  public Lead_Entry_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },

  ];
  public Lead_Entry_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Occupation', 'Town', 'Employee_Name'];
  public Lead_Entry_Row = [];
  get_Lead_Entry_Report() {
    this.isload = true;
    this.get("Api/reports/get_Lead_Entry_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt + "&Employee=" + this.Search_Employee_Rpt).subscribe((res: any) => {

      this.isload = false;
      this.Lead_Entry_Row = JSON.parse(res).record;
    });

  }

  public Status_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Lead_Rating', Name: 'Rating', Align: 'right' },
    { Field: 'Lead_Status', Name: 'Lead Status', Align: 'right' },
    { Field: 'Remainder_Date', Name: 'Remainder Date', Align: 'right' },
    { Field: 'Remainder_Note', Name: 'Remainder Note', Align: 'right' },
    { Field: 'Status', Name: 'Status', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },

  ];
  public Status_Report_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Town', 'Occupation', 'Remainder_Date', 'Remainder_Note', 'Lead_Status', 'Status', 'Employee_Name'];
  public Status_Report_Row = [];
  get_Status_Report() {
    this.isload = true;
    this.get("Api/reports/get_Status_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt + "&Employee=" + this.Search_Employee_Rpt).subscribe((res: any) => {

      this.isload = false;
      this.Status_Report_Row = JSON.parse(res).record;
    });

  }


  public Follow_Up_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Status', Name: 'Status', Align: 'right' },
    { Field: 'Updated_Date', Name: 'Updated Date', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },
    { Field: 'Lead_Rating', Name: 'Rating', Align: 'right' },
    { Field: 'Lead_Status', Name: 'Lead Status', Align: 'right' },
    { Field: 'Remainder_Date', Name: 'Remainder Date', Align: 'right' },
    { Field: 'Remainder_Note', Name: 'Remainder Note', Align: 'right' },

  ];
  public Follow_Up_Report_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Town', 'Occupation', 'Updated_Date', 'Remainder_Date', 'Remainder_Note', 'Lead_Status', 'Status', 'Employee_Name'];
  public Follow_Up_Report_Row = [];
  get_Follow_Up_Report() {
    this.isload = true;
    this.get("Api/reports/get_Follow_Up_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt + "&Employee=" + this.Search_Employee_Rpt).subscribe((res: any) => {

      this.isload = false;
      this.Follow_Up_Report_Row = JSON.parse(res).record;
    });

  }




  public Dishonoured_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Lead_Rating', Name: 'Rating', Align: 'right' },
    { Field: 'Lead_Status', Name: 'Lead Status', Align: 'right' },
    { Field: 'Remainder_Date', Name: 'Remainder Date', Align: 'right' },
    { Field: 'Remainder_Note', Name: 'Remainder Note', Align: 'right' },
    { Field: 'Status', Name: 'Status', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },

  ];
  public Dishonoured_Report_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Town', 'Occupation', 'Remainder_Date', 'Remainder_Note', 'Lead_Status', 'Status', 'Employee_Name'];
  public Dishonoured_Report_Row = [];
  get_Dishonoured_Report() {
    this.isload = true;
    this.get("Api/reports/get_Dishonoured_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt + "&Employee=" + this.Search_Employee_Rpt).subscribe((res: any) => {

      this.isload = false;
      this.Dishonoured_Report_Row = JSON.parse(res).record;
    });

  }


  public Search_Customer = "";





  public lead_calendar_Report_Export = [
    { Field: 'Branch', Name: 'Branch', Align: '' },
    { Field: 'Staff', Name: 'Staff', Align: '' },
    { Field: '[Grand Total]', Name: 'Grand Total', Align: '' },

  ];
  public lead_calendar_Report_GF = ['Branch', 'Staff'];
  public lead_calendar_Report_Row = [];




  public FollowUp_calendar_Report_Export = [
    { Field: 'Branch', Name: 'Branch', Align: '' },
    { Field: 'Staff', Name: 'Staff', Align: '' },
    { Field: '[Grand Total]', Name: 'Grand Total', Align: '' },

  ];
  public FollowUp_calendar_Report_GF = ['Branch', 'Staff'];
  public FollowUp_calendar_Report_Row = [];



  public Dishonoured_calendar_Report_Export = [
    { Field: 'Branch', Name: 'Branch', Align: '' },
    { Field: 'Staff', Name: 'Staff', Align: '' },
    { Field: '[Grand Total]', Name: 'Grand Total', Align: '' },

  ];
  public Dishonoured_calendar_Report_GF = ['Branch', 'Staff'];
  public Dishonoured_calendar_Report_Row = [];



  getLocationLink(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {

          const { latitude, longitude } = position.coords;
          resolve(`https://www.google.com/maps?q=${latitude},${longitude}`);
        },
        (error) => {
          console.error('Error getting location:', error);
          resolve(null); // Resolve with null in case of an error
        }
      );
    });
  }

  public Pay_Mode = "";
  public Bill_Mode = "Cash";
  public Receiving_Bank = "0";
  public Cheque_No = "";
  public Cheque_Date = this.Today_Date;
  public Card_Charge = "";
  public Remarks = "";
  public pay_Mode_reset() {
    this.Pay_Mode = this.Cash_ID;
    this.Receiving_Bank = "0";
    this.Cheque_No = "";
    this.Cheque_Date = this.Today_Date;
    this.Card_Charge = "";
    this.Remarks = "";

  }

  public Donation_Export = [

    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_address', Name: 'Address', Align: '' },
    { Field: 'oc_contact_number', Name: 'Contact Number', Align: '' },
    { Field: 'oc_remarks', Name: 'Remarks', Align: '' },

    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];

  public Income_Export = [

    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_category', Name: 'Category', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_narration1', Name: 'Description', Align: '' },

    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    { Field: 'oc_created_by', Name: 'User', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];
  public Expense_Export = [

    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_category', Name: 'Category', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_narration1', Name: 'Description', Align: '' },

    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    { Field: 'oc_created_by', Name: 'User', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];
  public S_Exp_Category = "0";

  public oc_type = "";
  public Expense_Details_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_amount'];
  public Exp_Rows = [];
  public Exp_Total = 0;
  get_expense() {
    this.isload = true;
    this.Exp_Rows = [];
    this.get("Api/Transaction/get_OtherCollection_details?From=" + this.S_From + "&To=" + this.S_To + "&Type=" + this.oc_type).subscribe((res: any) => {
      this.Exp_Rows = JSON.parse(res).record;
      this.isload = false;
      try {
        this.Exp_Total = 0;
        this.Exp_Total = (this.Exp_Rows.reduce((sum, current) => sum + parseFloat(current.oc_amount), 0)).toFixed(2);
      } catch { }
    });

  }



  public Contra_Export = [

    { Field: 'Ref_No', Name: 'No', Align: '' },
    { Field: 'Ref_Date_', Name: 'Date', Align: '' },
    { Field: 'From_Account_', Name: 'From', Align: '' },
    { Field: 'To_Account_', Name: 'To', Align: '' },

    { Field: 'Naration', Name: 'Description', Align: '' },
    { Field: 'Amount', Name: 'Amount', Align: 'right' }

  ];

  public Contra_Details_GF = ['Naration', 'Amount', 'From_Account', 'To_Account'];
  public Contra_Rows = [];
  public Contra_Total = 0;
  get_Contra() {
    this.isload = true;
    this.Contra_Rows = [];
    this.get("Api/Transaction/get_Contra?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Contra_Rows = JSON.parse(res).record;
      this.isload = false;
      try {
        this.Contra_Total = 0;
        this.Contra_Total = (this.Contra_Rows.reduce((sum, current) => sum + parseFloat(current.Amount), 0)).toFixed(2);
      } catch { }
    });

  }


  public Donation_Report_Export = [
    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_address', Name: 'Address', Align: '' },
    { Field: 'oc_contact_number', Name: 'Contact Number', Align: '' },
    { Field: 'oc_remarks', Name: 'Remarks', Align: '' },

    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];
  public Donation_Report_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_narration1', 'oc_remarks', 'oc_amount'];
  public Donation_Report_Rows = [];
  get_Donation_Report() {
    this.isload = true;
    this.Donation_Report_Rows = [];
    this.get("Api/reports/get_Donation_Report?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Donation_Report_Rows = JSON.parse(res).record;
      this.isload = false;
    });

  }


  public Expense_Report_Export = [
    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_category', Name: 'Category', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_narration1', Name: 'Description', Align: '' },
    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    // { Field: 'oc_remarks', Name: 'Remarks', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];
  public Expense_Report_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_narration1', 'oc_remarks', 'oc_amount'];
  public Expense_Report_Rows = [];
  public Expense_Group_Report_Rows = [];
  get_Expense_Report() {
    this.isload = true;
    this.Expense_Report_Rows = [];
    this.get("Api/reports/get_Expense_Report?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Expense_Report_Rows = JSON.parse(res).record;
      this.isload = false;

      //   var category = [...new Set(this.Expense_Report_Rows.map(item => item.oc_category))];
      //   this.Expense_Group_Report_Rows = [];
      //   for (let data of category) {
      //     var Amount_ = (this.Itemwise_purchase_Row.filter(e => e.Item_Name == data).reduce((sum, current) => sum + parseFloat(current.Amount), 0)).toFixed(2);

      //     this.Expense_Group_Report_Rows.push({ Item_Name: data, Qty: Qty_, Amount: Amount_,Profit:Profit_ ,S_Rate:S_Rate_})
      //   }
    });

  }


  public Income_Report_Export = [
    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_category', Name: 'Category', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_narration1', Name: 'Description', Align: '' },
    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    // { Field: 'oc_remarks', Name: 'Remarks', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];
  public Income_Report_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_narration1', 'oc_remarks', 'oc_amount'];
  public Income_Report_Rows = [];
  get_Income_Report() {
    this.isload = true;
    this.Income_Report_Rows = [];
    this.get("Api/reports/get_Income_Report?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Income_Report_Rows = JSON.parse(res).record;
      this.isload = false;
    });

  }

  Ledger_ = "0";
  public Ledger_Wise_Expense_Export = [
    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_narration1', Name: 'Description', Align: '' },
    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }
  ];
  //public S_Category="";
  public Ledger_Wise_Expense_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_narration1', 'oc_remarks', 'oc_amount'];
  public Ledger_Wise_Expense_Rows = [];
  get_Ledger_Wise_Expense() {
    this.isload = true;
    this.Ledger_Wise_Expense_Rows = [];
    this.get("Api/reports/get_Ledger_Wise_Expense?From=" + this.S_From + "&To=" + this.S_To + "&Category=" + this.Category + "&Ledger=" + this.Ledger_).subscribe((res: any) => {
      this.Ledger_Wise_Expense_Rows = JSON.parse(res).record;
      this.isload = false;
    });

  }


  public Ledger_Wise_Income_Export = [
    { Field: 'oc_date', Name: 'Date', Align: '' },
    { Field: 'oc_ledger_name', Name: 'Ledger', Align: '' },
    { Field: 'oc_narration1', Name: 'Description', Align: '' },
    { Field: 'oc_paymode', Name: 'Pay Mode', Align: '' },
    { Field: 'oc_amount', Name: 'Amount', Align: 'right' }

  ];
  //public S_Category="";
  public Ledger_Wise_Income_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_narration1', 'oc_remarks', 'oc_amount'];
  public Ledger_Wise_Income_Rows = [];
  get_Ledger_Wise_Income() {
    this.isload = true;
    this.Ledger_Wise_Income_Rows = [];
    this.get("Api/reports/get_Ledger_Wise_Income?From=" + this.S_From + "&To=" + this.S_To + "&Category=" + this.Category + "&Ledger=" + this.Ledger_).subscribe((res: any) => {
      this.Ledger_Wise_Income_Rows = JSON.parse(res).record;
      this.isload = false;
    });

  }



  public DB_Bank_Row = [];
  // public DB_Bank_Total = 0;
  public DB_Bank_Lenth = 0; 

  get_DB_Bank_Details() {
    this.isload = true;
    this.DB_Bank_Row = [];
    this.get("Api/Reports/get_DB_Bank_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.DB_Bank_Row = JSON.parse(res).record;
      this.isload = false;
      try {
        this.DB_Bank_Lenth = this.DB_Bank_Row.length;

        this.DB_Bank_Total = this.DB_Bank_Row.reduce((sum, current) => sum + parseFloat(current.Amount), 0);
      } catch { }
    });

  }

  public Daybook_Export = [

    { Field: 'AC_Date', Name: 'Date', Align: ' ' },
    { Field: 'Ledger_Name', Name: 'Group', Align: ' ' },
    { Field: 'Ledger', Name: 'Ledger', Align: ' ' },
    { Field: 'Narration1', Name: 'Narration', Align: ' ' },

    { Field: 'Credit', Name: 'Credit', Align: 'right' },
    { Field: 'Debit', Name: 'Debit', Align: 'right' },
    { Field: 'Balance', Name: 'Balance', Align: 'right' }

  ];

  public Ledger_Report = [
    { Menu: 'Day Book', Link: '/report/day-book', class: '' },
  ];

  public Bank_Category = [];
  public Typewise_DayBook_Row = [];
  Pay_Mode_Rows = [];


  public Day_book_GF = ['Nar_Type', 'Created_by', 'Pay_Mode_', 'CR_AMT'];
  public S_Bank = "0";
  public day_Book_Short_by = "AC_Date";
  public cr = 0;
  public db = 0;
  public bal = 0;

  public Total = 0;
  public Rows = [];
  public Day_Book_Row = [];
  public get_day_Book() {
    this.isload = true;
    this.Day_Book_Row = [];
    this.get("Api/Reports/get_Daybook?From=" + this.S_From + "&To=" + this.S_To + "&Ledger_ID=" + this.S_Bank + "&Order_by=" + this.day_Book_Short_by).subscribe((res: any) => {

      this.Day_Book_Row = JSON.parse(res).record;
      this.isload = false;
      this.Total = 0;
      this.cr = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Credit), 0)).toFixed(2);
      this.db = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Debit), 0)).toFixed(2);
      this.bal = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Balance), 0)).toFixed(2);

      this.Total = this.cr - this.db;

      var Item = [...new Set(this.Day_Book_Row.map(item => item.Nar_Type))];
      this.Typewise_DayBook_Row = [];
      for (let data of Item) {
        var cr = (this.Day_Book_Row.filter(e => e.Nar_Type == data).reduce((sum, current) => sum + parseFloat(current.CR_AMT), 0)).toFixed(2);
        var db = (this.Day_Book_Row.filter(e => e.Nar_Type == data).reduce((sum, current) => sum + parseFloat(current.DB_AMT), 0)).toFixed(2);
        var rs = this.Day_Book_Row.filter(e => e.Nar_Type == data);

        this.Typewise_DayBook_Row.push({ Nar_Type: data, AC_Date: rs[0].AC_Date, CR_AMT: cr, DB_AMT: db })
      }

    });

  }

  public Sales_Report = [
    { Menu: 'Loan-wise', Link: '/finance/loan-wise/' + this.loan_category, class: '' },
    { Menu: 'Type-Wise', Link: '/finance/loantype-wise', class: '' },
    { Menu: 'Customer-wise', Link: '/finance/customer-wise', class: '' },
    // { Menu: 'Userwise', Link: '/report/sales-userwise', class: '' },
    // { Menu: 'Daywise', Link: '/report/sales-daywise', class: '' },
    // { Menu: 'Customerwise', Link: '/report/sales-partywise', class: '' },
    // { Menu: 'Paymodewise', Link: '/report/sales-paymodewise', class: '' },

  ];

  public Pending_Report = [
    { Menu: 'Pending-List', Link: '/finance/pending-list', class: '' },
    { Menu: 'Loan-wise', Link: '/finance/pending-loanwise', class: '' },
    { Menu: 'Customer-Wise', Link: '/finance/pending-customerwise', class: '' },
    { Menu: 'Customer-Ledger', Link: '/finance/customer-ledger', class: '' },
    // { Menu: 'Userwise', Link: '/report/sales-userwise', class: '' },
    // { Menu: 'Daywise', Link: '/report/sales-daywise', class: '' },
    // { Menu: 'Customerwise', Link: '/report/sales-partywise', class: '' },
    // { Menu: 'Paymodewise', Link: '/report/sales-paymodewise', class: '' },

  ];
  public pending_Customer_Row = [];
  public pending_Report_Row = [];
  public pending_Type_Row = [];
  public get_pending_report() {
    this.isload = true;
    this.Day_Book_Row = [];
    this.get("Api/loan/get_Loan_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&loan_type=" + this.loan_type).subscribe((res: any) => {

      this.Loan_Report_Row = JSON.parse(res).record;
      this.isload = false;
      this.Total = 0;
      // this.cr = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Credit), 0)).toFixed(2);
      // this.db = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Debit), 0)).toFixed(2);
      // this.bal = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Balance), 0)).toFixed(2);
      // this.Total = this.cr - this.db;

      this.Loan_Type_Row = [];
      var User = [...new Set(this.Loan_Report_Row.map(item => item.loan_type))];

      for (let data of User) {
        var sum = (this.Loan_Report_Row.filter(e => e.loan_type == data).reduce((sum, current) => sum + parseFloat(current.loan_amount), 0)).toFixed(2);
        var count = [...new Set((this.Loan_Report_Row.filter(e => e.loan_type == data)).map(item => item.loan_no))].length;
        this.Loan_Type_Row.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.Loan_Customer_Row = [];
      var customer = [...new Set(this.Loan_Report_Row.map(item => item.loan_cusname))];

      for (let data of customer) {
        var sum = (this.Loan_Report_Row.filter(e => e.loan_cusname == data).reduce((sum, current) => sum + parseFloat(current.loan_amount), 0)).toFixed(2);
        var count = [...new Set((this.Loan_Report_Row.filter(e => e.loan_cusname == data)).map(item => item.loan_no))].length;
        this.Loan_Customer_Row.push({ 'loan_cusname': data, 'count': count, 'Amount': sum });
      }

    });

  }

  public Loan_Customer_Row = [];
  public Loan_Report_Row = [];
  public Loan_Summary_Row = []; // new array for loan summary data (loan_no, loan_date, loan_cusname, loan_type, loan_category, loan_amount, loan_interest, loan_installment, loan_advanceint, paidamt, balance, pl_loanid)
  public Loan_Type_Row = [];
  public get_loan_report() {
    this.isload = true;
    this.Day_Book_Row = [];
    this.get("Api/loan/get_Loan_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&loan_type=" + this.loan_type + "&loan_category=" + this.loan_category).subscribe((res: any) => {

      this.Loan_Report_Row = JSON.parse(res).record;
      this.isload = false;
      this.Total = 0;

      this.Loan_Type_Row = [];
      var User = [...new Set(this.Loan_Report_Row.map(item => item.loan_type))];

      for (let data of User) {
        var sum = (this.Loan_Report_Row.filter(e => e.loan_type == data).reduce((sum, current) => sum + parseFloat(current.loan_amount), 0)).toFixed(2);
        var count = [...new Set((this.Loan_Report_Row.filter(e => e.loan_type == data)).map(item => item.loan_no))].length;
        this.Loan_Type_Row.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.Loan_Customer_Row = [];
      var customer = [...new Set(this.Loan_Report_Row.map(item => item.loan_cusname))];

      for (let data of customer) {
        var sum = (this.Loan_Report_Row.filter(e => e.loan_cusname == data).reduce((sum, current) => sum + parseFloat(current.loan_amount), 0)).toFixed(2);
        var count = [...new Set((this.Loan_Report_Row.filter(e => e.loan_cusname == data)).map(item => item.loan_no))].length;
        this.Loan_Customer_Row.push({ 'loan_cusname': data, 'count': count, 'Amount': sum });
      }

    });

  }

  // New: fetch the loan summary which includes paidamt and balance per loan
  public get_loan_summary() {
    this.isload = true;
    this.get("Api/loan/get_Loan_Summary?loan_category=" + (this.loan_category || '') + "&Company=" + (this.Company || '')).subscribe((res: any) => {
      try {
        this.Loan_Summary_Row = JSON.parse(res).record || [];
      } catch (e) {
        this.Loan_Summary_Row = [];
      }
      this.isload = false;

      // Optionally compute derived aggregates similar to get_loan_report
      this.Loan_Type_Row = [];
      var User = [...new Set(this.Loan_Summary_Row.map(item => item.loan_type))];

      for (let data of User) {
        var sum = (this.Loan_Summary_Row.filter(e => e.loan_type == data).reduce((sum, current) => sum + parseFloat(current.loan_amount || 0), 0)).toFixed(2);
        var count = [...new Set((this.Loan_Summary_Row.filter(e => e.loan_type == data)).map(item => item.loan_no))].length;
        this.Loan_Type_Row.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.Loan_Customer_Row = [];
      var customer = [...new Set(this.Loan_Summary_Row.map(item => item.loan_cusname))];

      for (let data of customer) {
        var sum = (this.Loan_Summary_Row.filter(e => e.loan_cusname == data).reduce((sum, current) => sum + parseFloat(current.loan_amount || 0), 0)).toFixed(2);
        var count = [...new Set((this.Loan_Summary_Row.filter(e => e.loan_cusname == data)).map(item => item.loan_no))].length;
        this.Loan_Customer_Row.push({ 'loan_cusname': data, 'count': count, 'Amount': sum });
      }

    });
  }



  public pending_loan_Row = [];
  public pending_Rows = [];
  public get_pending_list() {
    this.isload = true;
    this.Day_Book_Row = [];
    this.get("Api/loan/get_pending_list?date=" + this.S_From_ + "&loan_type=" + this.loan_type + "&Branch=" + this.Search_Branch).subscribe((res: any) => {

      this.pending_Rows = JSON.parse(res).record;
      this.isload = false;
      this.Total = 0;

      this.pending_Type_Row = [];
      var User = [...new Set(this.pending_Rows.map(item => item.loan_type))];

      for (let data of User) {
        var sum = (this.pending_Rows.filter(e => e.loan_type == data).reduce((sum, current) => sum + parseFloat(current.Interest), 0)).toFixed(2);
        var count = [...new Set((this.pending_Rows.filter(e => e.loan_type == data)).map(item => item.loan_no))].length;
        this.pending_Type_Row.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.pending_Customer_Row = [];
      var customer = [...new Set(this.pending_Rows.map(item => item.loan_cusname))];

      for (let data of customer) {
        var sum = (this.pending_Rows.filter(e => e.loan_cusname == data).reduce((sum, current) => sum + parseFloat(current.Interest), 0)).toFixed(2);
        var count = [...new Set((this.pending_Rows.filter(e => e.loan_cusname == data)).map(item => item.loan_no))].length;
        this.pending_Customer_Row.push({ 'loan_cusname': data, 'count': count, 'Amount': sum });
      }

    });

  }

  public Closing_Report = [
    { Menu: 'Loan-wise', Link: '/finance/loan-closing', class: '' },
    { Menu: 'Type-Wise', Link: '/finance/type-wise', class: '' },
    { Menu: 'Customer-wise', Link: '/finance/customer-closing', class: '' },
    // { Menu: 'Userwise', Link: '/report/sales-userwise', class: '' },
    // { Menu: 'Daywise', Link: '/report/sales-daywise', class: '' },
    // { Menu: 'Customerwise', Link: '/report/sales-partywise', class: '' },
    // { Menu: 'Paymodewise', Link: '/report/sales-paymodewise', class: '' },

  ];


  public closing_Customer_Row = [];
  public closing_Report_Row = [];
  public closing_Type_Row = [];
  public get_closing_report() {
    this.isload = true;
    this.Day_Book_Row = [];
    this.get("Api/loan/get_Loan_closing?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch + "&loan_type=" + this.loan_type).subscribe((res: any) => {

      this.closing_Report_Row = JSON.parse(res).record;
      this.isload = false;
      this.Total = 0;
      // this.cr = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Credit), 0)).toFixed(2);
      // this.db = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Debit), 0)).toFixed(2);
      // this.bal = (this.Day_Book_Row.reduce((sum, current) => sum + parseFloat(current.Balance), 0)).toFixed(2);
      // this.Total = this.cr - this.db;

      this.closing_Type_Row = [];
      var User = [...new Set(this.closing_Report_Row.map(item => item.loan_type))];

      for (let data of User) {
        var sum = (this.closing_Report_Row.filter(e => e.loan_type == data).reduce((sum, current) => sum + parseFloat(current.loan_amount), 0)).toFixed(2);
        var count = [...new Set((this.closing_Report_Row.filter(e => e.loan_type == data)).map(item => item.loan_no))].length;
        this.closing_Type_Row.push({ 'LoanType': data, 'count': count, 'Amount': sum });
      }

      this.closing_Customer_Row = [];
      var customer = [...new Set(this.closing_Report_Row.map(item => item.loan_cusname))];

      for (let data of customer) {
        var sum = (this.closing_Report_Row.filter(e => e.loan_cusname == data).reduce((sum, current) => sum + parseFloat(current.loan_amount), 0)).toFixed(2);
        var count = [...new Set((this.closing_Report_Row.filter(e => e.loan_cusname == data)).map(item => item.loan_no))].length;
        this.closing_Customer_Row.push({ 'loan_cusname': data, 'count': count, 'Amount': sum });
      }

    });

  }


  public Loan_wise_Export = [

    { Field: 'loan_no', Name: 'Loan No', Align: '' },
    { Field: 'loan_date', Name: 'Date', Align: '' },
    { Field: 'loan_cusname', Name: 'Customer Name', Align: '' },
    { Field: 'loan_type', Name: 'Loan Type', Align: '' },
    { Field: 'loan_amount', Name: 'Amount', Align: 'right' },
    { Field: 'loan_interest', Name: 'Int%', Align: 'right' },
    { Field: 'loan_installment', Name: 'Installment', Align: 'right' },
    { Field: 'loan_created_by', Name: 'Create By', Align: 'right' }

  ];

  public Loan_wise_GF = ['loan_cusname', 'loan_no', 'loan_date', 'loan_type', 'loan_created_by'];


  public Gold_Mortgage_Export = [
    { Field: 'gm_customer', Name: 'Customer', Align: '' },
    { Field: 'gm_bank', Name: 'Bank', Align: '' },
    { Field: 'gm_loan_no', Name: 'Loan No', Align: '' },
    { Field: 'gm_loan_date', Name: 'Loan Date', Align: '' },
    { Field: 'gm_loan_amount', Name: 'Loan Amount', Align: 'right' },
    { Field: 'gm_commission_rps', Name: 'Commission RPS', Align: 'right' },
    { Field: 'gm_total', Name: 'Total', Align: 'right' },
    { Field: 'rc_pending_amt', Name: 'Pending Amount', Align: 'right' }
  ];

  public mortgage_rows = [];
  public selected_mortgage_data: any = null;
  public mortgage_report_rows = [];
  public mortgage_auction_rows = [];
  public delete_gold_mortgage(gm_sno: any) {
    this.isload = true;
    // API expects GET with query parameters: ID, UserName, Company
    const url = "Api/Transaction/Delete_Gold_Mortgage?ID=" + gm_sno + "&UserName=" + this.CREATED_BY + "&Company=" + this.Company;

    this.get(url).subscribe((res: any) => {
      this.isload = false;
      try {
        // API returns JSON string, parse it
        const result = JSON.parse(res);
        if (result && result.length >= 0) { // Update query returns affected rows
          try { this.toastr.success('Record deleted successfully', 'Success'); } catch (e) { }
          // Refresh the list
          this.get_gold_mortgage();
        } else {
          try { this.toastr.error('Failed to delete record', 'Error'); } catch (e) { }
        }
      } catch (e) {
        console.error('Failed to parse delete response', e, res);
        try { this.toastr.success('Record deleted successfully', 'Success'); } catch (e) { }
        // Still refresh the list even if parsing fails
        this.get_gold_mortgage();
      }
    }, (err) => {
      this.isload = false;
      console.error('Error deleting gold mortgage', err);
      try { this.toastr.error('Error deleting record', 'Error'); } catch (e) { }
    });
  }
  public get_gold_mortgage() {
    this.isload = true;
    this.mortgage_rows = [];
    const url = "Api/reports/get_mortgage_report?From=" + this.S_From + "&To=" + this.S_To;
    console.log('[AppService] get_gold_mortgage start ->', this.Server_URL + url + '&Company=' + this.Company);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_gold_mortgage timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        this.mortgage_rows = JSON.parse(res).record;
        console.log('[AppService] get_gold_mortgage response data:', this.mortgage_rows);
        if (this.mortgage_rows && this.mortgage_rows.length > 0) {
          console.log('[AppService] First row structure:', this.mortgage_rows[0]);
          console.log('[AppService] Available fields:', Object.keys(this.mortgage_rows[0]));
        }
      } catch (e) {
        console.error('Failed to parse get_gold_mortgage response', e, res);
        this.mortgage_rows = [];
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading gold mortgage rows', err);
      this.mortgage_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Gold Mortgage data', 'Error'); } catch (e) { }
    });
  }

  public get_datewise_mortgage() {
    this.isload = true;
    this.mortgage_rows = [];
    const url = "Api/reports/get_mortgage_report?From=" + this.S_From + "&To=" + this.S_To;
    this.get(url).subscribe((res: any) => {
      try {
        this.mortgage_rows = JSON.parse(res).record;
      } catch (e) {
        console.error('Failed to parse datewise mortgage response', e);
        this.mortgage_rows = [];
      }
      this.isload = false;
    }, (err) => {
      console.error('Error loading datewise mortgage', err);
      this.mortgage_rows = [];
      this.isload = false;
    });
  }

  public get_gold_mortgage_report() {
    this.isload = true;
    this.mortgage_report_rows = [];
    const url = "Api/reports/get_mortgage_report?From=" + this.S_From + "&To=" + this.S_To + "&Company=" + this.Company;
    console.log('[AppService] get_gold_mortgage_report start ->', this.Server_URL + url);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_gold_mortgage_report timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        this.mortgage_report_rows = JSON.parse(res).record;
        console.log('[AppService] get_gold_mortgage_report response data:', this.mortgage_report_rows);
        if (this.mortgage_report_rows && this.mortgage_report_rows.length > 0) {
          console.log('[AppService] First row structure:', this.mortgage_report_rows[0]);
          console.log('[AppService] Available fields:', Object.keys(this.mortgage_report_rows[0]));
        }
      } catch (e) {
        console.error('Failed to parse get_gold_mortgage_report response', e, res);
        this.mortgage_report_rows = [];
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading gold mortgage report rows', err);
      this.mortgage_report_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Gold Mortgage Report data', 'Error'); } catch (e) { }
    });
  }


  public cus_type = "customer";
  public mortgage_gold_GF = ['oc_date', 'oc_category', 'oc_ledger_name', 'oc_paymode', 'oc_narration1', 'oc_remarks', 'oc_amount'];
  public mortgage_goldRows = [];
  public datewise_mortgage: any[] = [];
  public mortgage_bankwise_rows: any[] = [];
  mortgage_gold() {
    this.isload = true;
    this.mortgage_goldRows = [];
    this.get("Api/master/get_mortgage_gold?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.mortgage_goldRows = JSON.parse(res).record;
      // Ensure all required fields are present for editing
      this.mortgage_goldRows.forEach(row => {
        // Map receipt number fields
        if (!row.gm_recp_no && row.recp_no) {
          row.gm_recp_no = row.recp_no;
        }
        if (!row.gm_recp_no && row.gm_recpno) {
          row.gm_recp_no = row.gm_recpno;
        }
        // Calculate commission percentage if not present
        if (row.gm_loan_amount && row.gm_commission && !row.gm_com_per) {
          row.gm_com_per = ((row.gm_commission / row.gm_loan_amount) * 100).toFixed(2);
        }
        // Map payment mode text to numeric values for dropdown compatibility
        if (row.gm_paymode) {
          const paymodeText = row.gm_paymode.toString().toLowerCase();
          if (paymodeText === 'cash' || paymodeText === '1') {
            row.gm_paymode = '1';
          } else if (paymodeText === 'bank transfer' || paymodeText === '2') {
            row.gm_paymode = '2';
          } else if (paymodeText === 'cheque' || paymodeText === '3') {
            row.gm_paymode = '3';
          } else if (paymodeText === 'upi' || paymodeText === '4') {
            row.gm_paymode = '4';
          } else {
            row.gm_paymode = '1'; // Default to Cash
          }
        } else {
          row.gm_paymode = '1'; // Default to Cash
        }
        // Map bank ID to bank name for Bank From field if needed
        if (row.gm_bank && this.customer_bank_master_rows && this.customer_bank_master_rows.length > 0) {
          const bankId = row.gm_bank.toString();
          const bankData = this.customer_bank_master_rows.find(b => String(b.ID) === bankId);
          if (bankData && bankData.Bank_Name) {
            row.gm_bank = bankData.Bank_Name;
          }
        }
        // Set default values for missing fields
        if (!row.gm_bankid) row.gm_bankid = "0";
      });
      this.isload = false;
    });

  }



  public get_auction_bankwise(bank: string = "") {
    this.isload = true;
    this.bankwise_auction_rows = [];
    const url = "Api/reports/get_auction_bankwise?From=" + this.S_From + "&To=" + this.S_To + "&Bank=" + bank;
    console.log('[AppService] get_auction_bankwise start ->', this.Server_URL + url);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_auction_bankwise timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        // Check if response is an error message from the API
        if (typeof res === 'string' && res.startsWith('Error:')) {
          console.error('API returned error:', res);
          this.bankwise_auction_rows = [];
          try { this.toastr.error('API Error: ' + res.substring(6), 'Error'); } catch (e) { }
        } else {
          this.bankwise_auction_rows = JSON.parse(res).record;
          console.log('[AppService] get_auction_bankwise response data:', this.bankwise_auction_rows);
          if (this.bankwise_auction_rows && this.bankwise_auction_rows.length > 0) {
            console.log('[AppService] First row structure:', this.bankwise_auction_rows[0]);
            console.log('[AppService] Available fields:', Object.keys(this.bankwise_auction_rows[0]));

            // Map bank ID to bank name
            this.bankwise_auction_rows.forEach(row => {
              if (row.ga_bankid && this.customer_bank_master_rows && this.customer_bank_master_rows.length > 0) {
                const bankId = row.ga_bankid.toString();
                const bankData = this.customer_bank_master_rows.find(b => String(b.ID) === bankId);
                if (bankData && bankData.Bank_Name) {
                  row.ga_bank_name = bankData.Bank_Name;
                }
              }
            });
          }
        }
      } catch (e) {
        console.error('Failed to parse get_auction_bankwise response', e, res);
        this.bankwise_auction_rows = [];
        try { this.toastr.error('Failed to parse API response', 'Error'); } catch (e) { }
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading bankwise auction rows', err);
      console.error('Error status:', err.status);
      console.error('Error message:', err.message);
      console.error('Error URL:', this.Server_URL + url);
      this.bankwise_auction_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Bankwise Auction data', 'Error'); } catch (e) { }
    });
  }

  public get_catwise_auction_report(category: string = "") {
    this.isload = true;
    this.catwise_auction_rows = [];
    const url = "Api/reports/get_auction_catwise?From=" + this.S_From + "&To=" + this.S_To + "&Category=" + category + "&Company=" + this.Company;
    console.log('[AppService] get_catwise_auction_report start ->', this.Server_URL + url);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_catwise_auction_report timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        this.catwise_auction_rows = JSON.parse(res).record;
        console.log('[AppService] get_catwise_auction_report response data:', this.catwise_auction_rows);
        if (this.catwise_auction_rows && this.catwise_auction_rows.length > 0) {
          console.log('[AppService] First row structure:', this.catwise_auction_rows[0]);
          console.log('[AppService] Available fields:', Object.keys(this.catwise_auction_rows[0]));

          // Map bank ID to bank name
          this.catwise_auction_rows.forEach(row => {
            if (row.ga_bankid && this.customer_bank_master_rows && this.customer_bank_master_rows.length > 0) {
              const bankId = row.ga_bankid.toString();
              const bankData = this.customer_bank_master_rows.find(b => String(b.ID) === bankId);
              if (bankData && bankData.Bank_Name) {
                row.ga_bank_name = bankData.Bank_Name;
              }
            }
          });
        }
      } catch (e) {
        console.error('Failed to parse get_catwise_auction_report response', e, res);
        this.catwise_auction_rows = [];
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading catwise auction report rows', err);
      this.catwise_auction_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Catwise Auction Report data', 'Error'); } catch (e) { }
    });
  }


  public Bankwise_Mortgage_Export = [
    { Field: 'gm_recp_no', Name: 'Receipt No', Align: '' },
    { Field: 'gm_bank', Name: 'Bank', Align: '' },
    { Field: 'gm_total', Name: 'Total Amount', Align: 'right' }
  ];

  public Datewise_Mortgage_Export = [
    { Field: 'gm_recp_no', Name: 'Receipt No', Align: '' },
    { Field: 'gm_bank', Name: 'Bank', Align: '' },
    { Field: 'gm_loan_date', Name: 'Date', Align: '' },
    { Field: 'gm_loan_amount', Name: 'Amount', Align: 'right' },
    { Field: 'gm_commission', Name: 'Commission', Align: 'right' },
    { Field: 'gm_total', Name: 'Total Amount', Align: 'right' }
  ];


  // Fetch receive mortgage records from the server (safe, with timeout)
  public get_receive_mortgage() {
    this.isload = true;
    this.receive_mortgae_rows = [];
    const url = "Api/master/get_receive_mortgage?From=" + this.S_From + "&To=" + this.S_To;

    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_receive_mortgage timed out after 15s');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe({
      next: (res: any) => {
        try {
          const parsed = JSON.parse(res);
          this.receive_mortgae_rows = Array.isArray(parsed.record) ? parsed.record : [];
        } catch (e) {
          console.error('[AppService] Failed to parse get_receive_mortgage response', e);
          this.receive_mortgae_rows = [];
        }
      },
      error: (err) => {
        console.error('[AppService] Error loading receive mortgage rows', err);
        this.receive_mortgae_rows = [];
        try { this.toastr.error('Failed to load Receive Mortgage data', 'Error'); } catch (e) { }
      },
      complete: () => {
        this.isload = false;
        clearTimeout(safety);
      }
    });
  }
  public receive_mortgae_rows = [];


  public selectedBank = "";
  get_mortgage_bankwise() {
    console.log('[AppService] get_mortgage_bankwise called');
    console.log('[AppService] S_From:', this.S_From, 'S_To:', this.S_To, 'selectedBank:', this.selectedBank);

    // Validate date range
    if (this.S_From && this.S_To && new Date(this.S_From) > new Date(this.S_To)) {
      this.toastr.error('From date cannot be after To date', 'Error');
      return;
    }

    // Check if dates are empty
    if (!this.S_From || !this.S_To) {
      this.toastr.error('Please select both From and To dates', 'Error');
      return;
    }

    this.isload = true;
    this.mortgage_bankwise_rows = [];

    // Build URL with parameters: From, To, Company, Bank (optional)
    let url = "Api/master/get_mortgage_datewise?From=" + this.S_From +
      "&To=" + this.S_To +
      "&Company=" + this.Company;

    if (this.selectedBank && this.selectedBank !== "") {
      // Find bank name from ID
      const selectedBankData = this.customer_bank_master_rows?.find(bank => String(bank.ID) === String(this.selectedBank));
      const bankName = selectedBankData ? selectedBankData.Bank_Name : this.selectedBank;
      url += "&Bank=" + encodeURIComponent(bankName);
      console.log('[AppService] get_mortgage_bankwise using bank name:', bankName);
    }

    console.log('[AppService] get_mortgage_bankwise calling URL:', this.Server_URL + url);

    this.get(url).subscribe({
      next: (res: any) => {
        console.log('[AppService] get_mortgage_bankwise response received:', res);
        try {
          this.mortgage_bankwise_rows = JSON.parse(res).record || [];
          console.log('[AppService] get_mortgage_bankwise parsed data:', this.mortgage_bankwise_rows);

          // Ensure all required fields are present for editing
          this.mortgage_bankwise_rows.forEach(row => {
            // Map receipt number fields
            if (!row.gm_recp_no && row.recp_no) {
              row.gm_recp_no = row.recp_no;
            }
            if (!row.gm_recp_no && row.gm_recpno) {
              row.gm_recp_no = row.gm_recpno;
            }
            // Calculate commission percentage if not present
            if (row.gm_loan_amount && row.gm_commission && !row.gm_com_per) {
              row.gm_com_per = ((row.gm_commission / row.gm_loan_amount) * 100).toFixed(2);
            }
            // Map payment mode text to numeric values for dropdown compatibility
            if (row.gm_paymode) {
              const paymodeText = row.gm_paymode.toString().toLowerCase();
              if (paymodeText === 'cash' || paymodeText === '1') {
                row.gm_paymode = '1';
              } else if (paymodeText === 'bank transfer' || paymodeText === '2') {
                row.gm_paymode = '2';
              } else if (paymodeText === 'cheque' || paymodeText === '3') {
                row.gm_paymode = '3';
              } else if (paymodeText === 'upi' || paymodeText === '4') {
                row.gm_paymode = '4';
              } else {
                row.gm_paymode = '1'; // Default to Cash
              }
            } else {
              row.gm_paymode = '1'; // Default to Cash
            }
            // Map bank ID to bank name for Bank From field if needed
            if (row.gm_bank && this.customer_bank_master_rows && this.customer_bank_master_rows.length > 0) {
              const bankId = row.gm_bank.toString();
              const bankData = this.customer_bank_master_rows.find(b => String(b.ID) === bankId);
              if (bankData && bankData.Bank_Name) {
                row.gm_bank = bankData.Bank_Name;
              }
            }
            // Set default values for missing fields
            if (!row.gm_bankid) row.gm_bankid = "0";
          });

          this.isload = false;
          console.log('[AppService] get_mortgage_bankwise completed successfully');
        } catch (parseError) {
          console.error('[AppService] get_mortgage_bankwise parse error:', parseError);
          this.toastr.error('Failed to parse response data', 'Error');
          this.mortgage_bankwise_rows = [];
          this.isload = false;
        }
      },
      error: (error) => {
        console.error('[AppService] get_mortgage_bankwise error:', error);
        this.toastr.error('Failed to load bankwise mortgage data', 'Error');
        this.isload = false;
      }
    });
  }


  public selectedCategory = "All";
  public get_gold_action_report() {
    this.isload = true;
    this.gold_action_report_rows = [];
    const url = "Api/reports/get_auction_report?From=" + this.S_From + "&To=" + this.S_To + (this.selectedCategory !== "All" ? "&Category=" + this.selectedCategory : "");
    console.log('[AppService] get_gold_action_report start ->', this.Server_URL + url);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_gold_action_report timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        this.gold_action_report_rows = JSON.parse(res).record;
        console.log('[AppService] get_gold_action_report response data:', this.gold_action_report_rows);
        if (this.gold_action_report_rows && this.gold_action_report_rows.length > 0) {
          console.log('[AppService] First row structure:', this.gold_action_report_rows[0]);
          console.log('[AppService] Available fields:', Object.keys(this.gold_action_report_rows[0]));

          // Map bank ID to bank name
          this.gold_action_report_rows.forEach(row => {
            if (row.ga_bankid && this.customer_bank_master_rows && this.customer_bank_master_rows.length > 0) {
              const bankId = row.ga_bankid.toString();
              const bankData = this.customer_bank_master_rows.find(b => String(b.ID) === bankId);
              if (bankData && bankData.Bank_Name) {
                row.ga_bank_name = bankData.Bank_Name;
              }
            }
          });
        }
      } catch (e) {
        console.error('Failed to parse get_gold_action_report response', e, res);
        this.gold_action_report_rows = [];
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading gold action report rows', err);
      this.gold_action_report_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Gold Action Report data', 'Error'); } catch (e) { }
    });
  }


  // Gold Auction methods
  public gold_auction_rows = [];
  public gold_action_report_rows = [];
  public catwise_auction_rows = [];
  public bankwise_auction_rows = [];
  public selected_auction_data: any = null;

  public Gold_Auction_Export = [
    { Field: 'ga_bank_name', Name: 'Bank Name', Align: '' },
    { Field: 'ga_category', Name: 'Category', Align: '' },
    { Field: 'ga_weight', Name: 'Weight', Align: 'right' },
    { Field: 'ga_rate', Name: 'Rate', Align: 'right' },
    { Field: 'ga_auction_amount', Name: 'Auction Amount', Align: 'right' }
  ];

  public Gold_Auction_Report_Export = [
    { Field: 'ga_bank_name', Name: 'Bank Name', Align: '' },
    { Field: 'ga_category', Name: 'Category', Align: '' },
    { Field: 'ga_weight', Name: 'Weight', Align: 'right' },
    { Field: 'ga_rate', Name: 'Rate', Align: 'right' },
    { Field: 'ga_auction_amount', Name: 'Auction Amount', Align: 'right' },
    { Field: 'ga_created_by', Name: 'Created By', Align: '' },
    { Field: 'ga_created_date', Name: 'Created Date', Align: '' },
    { Field: 'ga_status', Name: 'Status', Align: '' }
  ];

  public delete_gold_auction(ga_id: any) {
    this.isload = true;
    // API expects GET with query parameters: ID, UserName, Company
    const url = "Api/Transaction/Delete_Gold_Auction?ID=" + ga_id + "&UserName=" + this.CREATED_BY + "&Company=" + this.Company;

    this.get(url).subscribe((res: any) => {
      this.isload = false;
      try {
        // API returns JSON string, parse it
        const result = JSON.parse(res);
        if (result && result.length >= 0) { // Update query returns affected rows
          try { this.toastr.success('Record deleted successfully', 'Success'); } catch (e) { }
          // Refresh the list
          this.get_gold_auction();
        } else {
          try { this.toastr.error('Failed to delete record', 'Error'); } catch (e) { }
        }
      } catch (e) {
        console.error('Failed to parse delete response', e, res);
        try { this.toastr.success('Record deleted successfully', 'Success'); } catch (e) { }
        // Still refresh the list even if parsing fails
        this.get_gold_auction();
      }
    }, (err) => {
      this.isload = false;
      console.error('Error deleting gold auction', err);
      try { this.toastr.error('Error deleting record', 'Error'); } catch (e) { }
    });
  }

  public get_gold_auction() {
    this.isload = true;
    this.gold_auction_rows = [];
    const url = "Api/reports/get_auction_report?From=" + this.S_From + "&To=" + this.S_To + "&Company=" + this.Company;
    console.log('[AppService] get_gold_auction start ->', this.Server_URL + url + '&Company=' + this.Company);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_gold_auction timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        this.gold_auction_rows = JSON.parse(res).record;
        console.log('[AppService] get_gold_auction response data:', this.gold_auction_rows);
        if (this.gold_auction_rows && this.gold_auction_rows.length > 0) {
          console.log('[AppService] First row structure:', this.gold_auction_rows[0]);
          console.log('[AppService] Available fields:', Object.keys(this.gold_auction_rows[0]));
        }
      } catch (e) {
        console.error('Failed to parse get_gold_auction response', e, res);
        this.gold_auction_rows = [];
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading gold auction rows', err);
      this.gold_auction_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Gold Auction data', 'Error'); } catch (e) { }
    });
  }

  public get_gold_auction_report() {
    this.isload = true;
    this.mortgage_auction_rows = [];
    const url = "Api/reports/get_auction_report?From=" + this.S_From + "&To=" + this.S_To + "&Company=" + this.Company;
    console.log('[AppService] get_gold_auction_report start ->', this.Server_URL + url);
    // safety timeout: clear spinner if request doesn't respond in 15s
    const safety = setTimeout(() => {
      if (this.isload) {
        console.warn('[AppService] get_gold_auction_report timed out after 15s, clearing spinner');
        this.isload = false;
      }
    }, 15000);

    this.get(url).subscribe((res: any) => {
      try {
        this.mortgage_auction_rows = JSON.parse(res).record;
        console.log('[AppService] get_gold_auction_report response data:', this.mortgage_auction_rows);
        if (this.mortgage_auction_rows && this.mortgage_auction_rows.length > 0) {
          console.log('[AppService] First row structure:', this.mortgage_auction_rows[0]);
          console.log('[AppService] Available fields:', Object.keys(this.mortgage_auction_rows[0]));
        }
      } catch (e) {
        console.error('Failed to parse get_gold_auction_report response', e, res);
        this.mortgage_auction_rows = [];
      }
      this.isload = false;
      clearTimeout(safety);
    }, (err) => {
      console.error('Error loading gold auction report rows', err);
      this.mortgage_auction_rows = [];
      this.isload = false;
      clearTimeout(safety);
      try { this.toastr.error('Failed to load Gold Auction Report data', 'Error'); } catch (e) { }
    });
  }

}
